import { useDispatch, useSelector } from 'react-redux';
// import { CloseOutlined } from '@ant-design/icons';
import { Company } from 'Types/CompaniesTypes';
// import { usePrevious } from 'Utils/hooks/usePrevious';
import { actions as searchActions } from 'Slice/GlobalSearchResultsSlice';

import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { useLocation } from 'react-router-dom';
import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import { actions as onboardingActions } from '../../../Slice/OnboardingSlice';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';
import { actions as flurryActions } from '../../../Slice/HelperSlice';
import SmallButton from './SmallButton';

type Props = {
  companyData?: Company,
  isSearch?: boolean,
  removeButton?: boolean
} & typeof defaultProps;

const defaultProps = {
  companyData: {},
  isSearch: false,
  removeButton: false,
};

const CompanyFollowUnFollowButton = function CompanyFollowUnFollowButton(props: Props) {
  const {
    companyData,
    isSearch,
    removeButton,
  } = props;

  const {
    companySubscribed,
    companyId,
    loading,
    companyName,
  } = companyData;

  const host = window.location.href;
  const location = useLocation();
  const isOnboardingRoute = location.pathname === '/onboarding';
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const startTime = getCurrentTime();
  const getTitleForButton = () => {
    if (!companySubscribed) {
      if (loading) return 'Following';
      return 'Follow';
    }
    if (loading) return 'Unfollowing';
    return 'Unfollow';
  };

  const handleButtonClicked = () => {
    const data = { companyId: `${companyId}`, companyName };
    if (companySubscribed) {
      dispatch(companiesActions.unFollowCompanies(
        { ...data, companyRemoved: companyData.companyName },
      ));
      dispatch(onboardingActions.handleCompanyUnFollow(data.companyId));
    } else {
      dispatch(companiesActions.followCompany({ ...data, companyAdded: companyData.companyName }));
      dispatch(onboardingActions.handleCompanyFollow(data.companyId));
    }
    if (isSearch) {
      dispatch(searchActions.searchCompanyFollowLoading(data));
      if (companySubscribed) {
        if (isOnboardingRoute) {
          dispatch(flurryActions.callFlurryEvent(
            valueToObject('click_Unfollow_FollowCompany_Onboarding', startTime, {
              company_id: companyId,
              company_name: companyName,
              host,
            }),
          ));
        }
      } else if (isOnboardingRoute) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Follow_FollowCompany_Onboarding', startTime, {
            company_id: companyId,
            company_name: companyName,
            host,
          }),
        ));
      }
    }
  };

  const data = useSelector(selectData);

  const handleClick = (e: React.MouseEvent<HTMLOrSVGElement>) => {
    e.stopPropagation();
    handleButtonClicked();
    if (!companySubscribed && !pathname.includes('onboarding')) {
      dispatch(certificationActions.certificationAction({
        type: 'company_follow',
        source: 'search',
        data,
      }));
    }
  };

  return (
    <SmallButton
      title={getTitleForButton()}
      variant={!companySubscribed ? 'filled' : 'outlined'}
      color="#001760"
      onButtonClick={handleClick}
      paddingSm="7px 15px"
      disabled={loading || removeButton}
    />
  );
};

CompanyFollowUnFollowButton.defaultProps = defaultProps;

export default CompanyFollowUnFollowButton;
